export function formatTime(date) {
    return date.toLocaleTimeString('hu', { hour: '2-digit', minute: '2-digit' });
}



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/time-utils.ts
// module id = 323
// module chunks = 0